package org.example.project.engineslot

import org.example.project.service.LoginService
import org.example.project.service.SnapApi
import org.example.project.screens_sys.UnternehmenstammApi
import org.example.project.setup.SetupApi
import org.example.project.setup.SetupNodeApi
import org.example.project.utils.All

private const val SLOT_SOURCE_TYPE = "slotSourceType"
private const val SLOT_SOURCE_OWN = "own"
private const val SLOT_SOURCE_SNAP = "snap"

data class SlotCompanyContext(
    val firmenId: String,
    val label: String,
    val sourceType: String,
    val userId: String
)

object SlotSnapCompanyApi {
    suspend fun loadSelectableCompanies(): List<All> {
        val currentFirmenId = currentFirmenId()
        val currentUserId = LoginService.getId().trim()
        val ownLabel = runCatching {
            UnternehmenstammApi.loadUnternehmen(currentFirmenId)?.firma
                .takeUnless { it.isNullOrBlank() }
                ?: SetupApi.loadCusDeckblatt(currentFirmenId)?.firma
        }.getOrNull().orEmpty().ifBlank { currentFirmenId }
        val ownEntry = All(
            key = currentFirmenId,
            label = ownLabel,
            firmenId = currentFirmenId,
            firma = ownLabel,
            source = SLOT_SOURCE_OWN
        )
        val partners = runCatching {
            SnapApi.loadPartners(currentUserId, currentFirmenId)
        }.getOrDefault(emptyList())
            .asSequence()
            .filter { partner ->
                partner.snapStatus == "verbunden" && partner.snapZeitfensterBuchen
            }
            .mapNotNull { partner ->
                val firmenId = partner.firmenId.trim()
                if (firmenId.isBlank()) null else partner.copy(
                    key = firmenId,
                    label = partner.firma.ifBlank { partner.kunde.ifBlank { firmenId } },
                    source = SLOT_SOURCE_SNAP
                )
            }
            .toList()

        return (listOf(ownEntry) + partners)
            .filter { it.key.isNotBlank() }
            .distinctBy { it.key }
            .sortedWith(compareBy<All> { if (it.key == currentFirmenId) 0 else 1 }.thenBy { it.label.lowercase() })
    }

    fun resolveContext(options: List<All>, selectedFirmenId: String): SlotCompanyContext {
        val normalizedFirmenId = selectedFirmenId.trim()
        val selected = options.firstOrNull { it.key == normalizedFirmenId }
            ?: options.firstOrNull().takeIf { normalizedFirmenId.isBlank() }
        val firmenId = selected?.key.orEmpty().ifBlank { normalizedFirmenId }
        val label = selected?.label.orEmpty().ifBlank { selected?.firma.orEmpty().ifBlank { firmenId } }
        val sourceType = selected?.source.orEmpty().ifBlank {
            if (firmenId.isBlank()) {
                SLOT_SOURCE_OWN
            } else if (selected == null && normalizedFirmenId.isNotBlank()) {
                SLOT_SOURCE_SNAP
            } else {
                SLOT_SOURCE_OWN
            }
        }
        val currentUserId = LoginService.getId().trim().ifBlank { "1" }
        return SlotCompanyContext(
            firmenId = firmenId,
            label = label,
            sourceType = sourceType,
            userId = if (sourceType == SLOT_SOURCE_OWN) currentUserId else "1"
        )
    }

    suspend fun currentFirmenId(): String =
        LoginService.getUser()?.firmenId.orEmpty().trim()
            .ifBlank { runCatching { SetupNodeApi.loadNodeFirmenId() }.getOrDefault("") }
}
